import type { CargoExclusion } from '../../graphql';

export enum CargoExclusionType {
  distance = 'distance',
  tanks = 'tanks',
  voyages = 'voyages',
}

type CargoExclusionTypeFields = Pick<CargoExclusion, CargoExclusionType>;

export function getCargoExclusionType(
  c: CargoExclusionTypeFields,
): CargoExclusionType | null {
  if (c.distance != null) {
    return CargoExclusionType.distance;
  } else if (c.tanks != null) {
    return CargoExclusionType.tanks;
  } else if (c.voyages != null) {
    return CargoExclusionType.voyages;
  } else {
    return null;
  }
}

export function getCargoExclusionValue(
  c: CargoExclusionTypeFields,
): number | null {
  if (
    typeof c.distance === 'string' &&
    Number.isFinite(parseInt(c.distance, 10))
  ) {
    return parseInt(c.distance, 10);
  } else if (typeof c.tanks == 'number') {
    return c.tanks;
  } else if (typeof c.voyages == 'number') {
    return c.voyages;
  } else {
    return null;
  }
}

export function buildCargoExclusion(
  type: CargoExclusionType,
  value: number,
  assortmentGroup: number,
): Pick<CargoExclusion, 'assortmentGroup' | 'distance' | 'tanks' | 'voyages'> {
  return {
    assortmentGroup,
    [type]: value,
  };
}
